module.exports = __webpack_public_path__ + "static/img/page_27.a3d8a4d3.png";